import { render } from "./EeiaAttachments.vue?vue&type=template&id=2a46094d&scoped=true"
import script from "./EeiaAttachments.vue?vue&type=script&lang=js"
export * from "./EeiaAttachments.vue?vue&type=script&lang=js"

import "./EeiaAttachments.vue?vue&type=style&index=0&id=2a46094d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeej-spa/eeej-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a46094d"]])

export default __exports__